import { format, formatDistanceToNow } from 'date-fns'
import { nl } from 'date-fns/locale'

/**
 * Date rendering for a Dutch interface, in one place.
 *
 * Two call sites rendered "5 days ago" in an otherwise Dutch UI because they
 * called formatDistanceToNow without `locale: nl` — the locale is opt-in, so
 * forgetting it produces English rather than an error. Routing every date
 * through here makes the locale impossible to omit.
 *
 * The split follows the rule in the cleanup plan: lists say how long ago,
 * detail views say when.
 */

/** "5 dagen geleden" — for lists, where age is the question. */
export function relatief(date: string | Date): string {
  return formatDistanceToNow(new Date(date), { addSuffix: true, locale: nl })
}

/** "7 sep 2026 14:03" — for detail views, where the moment is the question. */
export function absoluut(date: string | Date): string {
  return format(new Date(date), 'd MMM yyyy HH:mm', { locale: nl })
}

/** "7 sep 2026" — same, without the time. */
export function datumKort(date: string | Date): string {
  return format(new Date(date), 'd MMM yyyy', { locale: nl })
}
